/* JavaScript for ADV module form-b2b */

// Callback called by reCAPTCHA when the API is ready
window.__onRecaptchaApiLoaded_formB2B = function () {
    window.__recaptchaApiReady_formB2B = true;
};

function waitForRecaptchaApiReady({ timeoutMs = 10000, intervalMs = 50 } = {}) {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
            if (window.__recaptchaApiReady_formB2B && window.grecaptcha && typeof window.grecaptcha.render === 'function') {
                resolve(window.grecaptcha);
                return;
            }
            if (Date.now() - start >= timeoutMs) {
                reject(new Error('reCAPTCHA API not ready (timeout): grecaptcha.render unavailable'));
                return;
            }
            setTimeout(tick, intervalMs);
        };
        tick();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const formContainer = document.getElementById('form-b2b-container');

    if (formContainer) {
        Vue.component('wContactForm', wContactForm);

        fetch(path_relative_root + 'ajax-form-b2b.php', {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP error: ' + response.status);
                }

                return response.text();
            })
            .then(function (html) {
                // Add HTML response into the DOM
                formContainer.innerHTML = html;

                // Render the VueJS component
                const vueForm = new Vue({el: formContainer});

                vueForm.$nextTick(function () {
                    const recaptchaElement = document.querySelector('#recaptcha');
                    const responseMessageContainer = document.getElementById('message_mail');

                    // Render the captcha
                    if (recaptchaIsEnabled && recaptchaElement && typeof waitForRecaptchaApiReady === 'function') {
                        waitForRecaptchaApiReady().then((grecaptcha) => {
                            if (!recaptchaElement.dataset.rendered) {
                                grecaptcha.render(recaptchaElement, {sitekey: recaptchaElement.dataset.sitekey});
                                recaptchaElement.dataset.rendered = '1';
                            }
                        }).catch((err) => {
                            console.error('[B2B] reCAPTCHA init failed:', err);
                        });
                    }

                    // Form submitting event: handle the ajax response
                    window.addEventListener('contact_form_ajax_module_submit', (e) => {
                        responseMessageContainer.innerHTML = '';
                        document.getElementById('submit-token-error')?.remove();

                        // Reset recaptcha
                        if (recaptchaIsEnabled && recaptchaElement && recaptchaElement.dataset.rendered && window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
                            window.grecaptcha.reset();
                        }

                        // Handle errors
                        if (typeof e.detail.error !== 'undefined' && e.detail.error === 1) {

                            // Token error
                            if (typeof e.detail.result.token !== 'undefined') {
                                // Captcha error
                                if (recaptchaIsEnabled && recaptchaElement && recaptchaElement.dataset.rendered) {
                                    recaptchaElement.insertAdjacentHTML('beforeend',
                                        `<div class="w-input-container" id="submit-token-error">
                                            <small class="w-input-note w-input-error">${e.detail.result.token}</small>
                                        </div>`
                                    );
                                } else {
                                    // Security token error
                                    responseMessageContainer.insertAdjacentHTML('beforeend', `<span class="error red">${e.detail.result.token}</span>`);
                                }
                            }

                            // Mail sending error
                            if (typeof e.detail.result.sending_mail !== 'undefined') {
                                responseMessageContainer.insertAdjacentHTML('beforeend', `<span class="error red">${e.detail.result.sending_mail}</span>`);
                            }
                        } else if (typeof e.detail.result.sending_mail !== 'undefined' && e.detail.message === 'success') {
                            // Success message
                            responseMessageContainer.insertAdjacentHTML('beforeend', `<span class="valid">${e.detail.result.sending_mail}</span>`);
                        }
                    });
                });
            })
            .catch(function (error) {
                console.error('Unable to load the B2B form:', error);
            });
    }
});